import _get from 'lodash/get';

import { Google, GoogleTransformers } from 'reaxl-analytics-handlers';

import { getInventoryOwnerById } from '@/analytics/utilities';

const { inventoryTransformer: googleInventoryTransformer, productConfigTransformer } = GoogleTransformers;
const {
    transformProductConfig,
    hasPrice,
} = productConfigTransformer;
/**
 * @summary Sends Google impressions for dhs
 */
export function dhsImpressions(metadata, option) {
    const {
        data = {},
        state,
        dataLayer = {},
    } = metadata;

    const { inventoryId } = data;

    const inventory = getInventoryOwnerById(state, inventoryId);
    Google.sendImpressions(metadata, {
        eventElement: 'dhs',
        eventResult: 'dhs_vdp',
        eventNonInteractive: false,
        eventData: {
            vehicle: {
                ...googleInventoryTransformer(inventory, { target: 'vehicle', dataLayer }),
                ...transformProductConfig({
                    homeServices: _get(inventory, 'owner.homeServices', {}),
                    nds: hasPrice(inventory),
                }),
            },
        },
    }, option);
    return {};
}
